<template>
  <div class="tech-w">
    <img class="tech-timg" src="../../assets/img/tech/tech-t.png" alt="">
    <div class="tech-tabs">
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="技术创新" name="first">
          </el-tab-pane>
        </el-tabs>
      </div>
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: 'tech',
  data () {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick (tab, event) {
    }
  }
}
</script>
<style scoped>
.tech-timg{
  width: 100%;
  height: 400px;
}
.tech-tabs{
  width: 100%;
  margin: 20px auto;
}
.tabs{
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/view/tech.vue